"use client";

import React from "react";
import "leaflet/dist/leaflet.css";

// // Use explicit typing instead of React.FC
// const MapEmbed = ({ lat, lng }: MapEmbedProps) => {
//   // Define position with proper Leaflet type
//   const position = [lat, lng] as LatLngExpression;

//   return (
//     <MapContainer
//       center={position}
//       zoom={13}
//       style={{
//         height: "400px",
//         width: "100%",
//         borderRadius: "8px",
//         zIndex: 10,
//       }}
//     >
//       <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
//       <Marker position={position} icon={markerIcon} />
//     </MapContainer>
//   );
// };

// Usage Example

const MapEmbed: React.FC<{ lat: number; lng: number }> = ({ lat, lng }) => {
  const src = `https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`;

  return (
    <iframe
      width="100%"
      height="450"
      frameBorder="0"
      style={{ border: 0 }}
      src={src}
      allowFullScreen
      loading="lazy"
    ></iframe>
  );
};

const Example: React.FC<{ coordinates?: [number, number] }> = ({
  coordinates,
}) => {
  if (!coordinates) {
    return <div>No coordinates provided</div>;
  }

  const [lat, lng] = coordinates;

  return <MapEmbed lat={lat} lng={lng} />;
};

export default Example;

//  return <MapEmbed lat={6.4913408} lng={3.391488} />;

// export default function Example() {
//   return <MapEmbed lat={6.4913408} lng={3.391488} />;
// }
